import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { RadioGroup } from "@progress/kendo-react-inputs";
import { TextArea } from "@progress/kendo-react-inputs";
import { clearFilesDispPayment } from "actions/files.action";
import * as api from "../../api/index";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import PaySupplierGrid from "./PaySupplierGrid";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { toast } from "react-toastify";
import Modalposting from "components/BatchPosting/PostingsModal";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import styles from "./PaySupplier.module.scss";

const typeData = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Disbursements",
    value: "disbursements",
  },
  {
    label: "Purchase Invoices",
    value: "invoices",
  },
];

const PaySupplier = ({
  is_type,
  preSelectedData,
  preSelectedSupplier,
  onClose,
}) => {
  const dispatch = useDispatch();
  const date = new Date();

  // Initialize supplier in initialData if preSelected
  const [initialData] = useState({
    date: new Date(Date.now()),
    supplierRef: preSelectedSupplier || undefined,
    officeBank: undefined,
    feeEarner: undefined,
  });

  const [details, setDetails] = useState("");
  const [reference, setReference] = useState("");
  const [data, setData] = useState(
    preSelectedData?.length ? preSelectedData : []
  );
  const [payee, setPayee] = useState("");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("all");
  const [dateselector, setdateselector] = useState(date);
  const [supplierRef, setSupplierRef] = useState(
    preSelectedSupplier?.supplierRef
  );
  const [allocation, setAllocation] = useState(null);
  const [modalvalue, setmodalvalue] = useState();
  const [isSupplierLocked, setIsSupplierLocked] = useState(
    !!preSelectedSupplier
  );
  const [validationAttempted, setValidationAttempted] = useState(false);

  // // // Initialize with preselected data only once on mount
  // useEffect(() => {
  //   if (preSelectedData && preSelectedData.length > 0) {
  //     setData(preSelectedData);
  //   }
  // }, []);

  const filesCurrentData = useSelector(
    (state) => state.filesDownload.disbPaymentFiles
  );

  const getSupplierData = async (supplierRef) => {
    if (supplierRef) {
      let transactiontype = type;
      if (type === "all") transactiontype = undefined;
      const datas = await api.getPaySupplierList(
        supplierRef,
        transactiontype,
        is_type
      );
      datas?.data?.data.forEach((element) => {
        element.inEdit = true;
        element.add = false;
        element.amount = 0;
      });
      setData(datas?.data?.data);
    } else {
      setData([]);
    }
  };

  const onChangeSupplier = async (event) => {
    if (isSupplierLocked) return; // Prevent changes when locked

    try {
      getSupplierData(event?.value?.supplierRef);
      setSupplierRef(event?.value?.supplierRef);
    } catch (error) {
      console.error(error);
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  useEffect(() => {
    // Don't refetch if we're using preselected data (supplier locked)
    if (supplierRef && !isSupplierLocked) {
      getSupplierData(supplierRef);
    }
  }, [type]);

  // Memoize callbacks to prevent PaySupplierGrid re-renders
  const handleUpdateAllocations = useCallback((value) => {
    setAllocation(value);
  }, []);

  const handleSetAmount = useCallback(() => {
    // Empty function - grid calculates internally
  }, []);

  const requiredValidator = (value) => {
    return value ? "" : "Required";
  };

  async function Submithandler(value) {
    // Check required fields
    if (!value?.supplierRef || !value?.officeBank || !value?.feeEarner || !reference || !payee || !details) {
      setValidationAttempted(true);
      return;
    }

    const data = [
      {
        timeId: 0,
        postingType: "SUP",
        reference: reference,
        supplierRef: value?.supplierRef?.supplierRef,
        feeEarnerRef: value?.feeEarner?.userRef,
        date: dateselector,
        netAmount: amount,
        transactionPeriod: 202201,
        currencyCode: "GBP",
        details: details,
        reference: reference,
        Payee: payee,
        OfficeBank: value?.officeBank?.nominalRef,
      },
    ];

    if (allocation !== null) {
      data[0].allocations = allocation;
    }
    if (filesCurrentData[0] !== undefined) {
      const docsId = [];
      filesCurrentData.map((item) => {
        docsId.push(item.fileID);
      });
      data[0].DocumentFiles = docsId;
    }
    let totalAllocatedAmount = 0;
    allocation.forEach((item) => {
      totalAllocatedAmount += item.amount;
    });
    if (totalAllocatedAmount !== amount) {
      toast.error("Allocated amount should be equal to net amount");
      return;
    }
    setLoading(true);
    try {
      const response = await api.createposting(data);

      if (isModalMode) {
        // In modal mode, show toast and close modal
        if (response?.status === 200 || response?.status === 201) {
          const responseData = response?.data?.data?.[0];
          const transactionNo = responseData?.transactionNo;
          const details = responseData?.details || "Transaction successful";
          const message = transactionNo 
            ? `${details} (Transaction No: ${transactionNo})` 
            : details;
          toast.success(message);

          // Close modal and refresh
          setValidationAttempted(false);
          if (onClose) {
            onClose();
          }
        } else {
          toast.error("Transaction failed");
        }
      } else {
        // In tab mode, show the modal popup as usual
        setmodalvalue({
          code: response?.status,
          data: response?.data,
        });
      }
    } catch (error) {
      if (isModalMode) {
        toast.error(error?.response?.data?.error || "Transaction failed");
      } else {
        setmodalvalue({
          code: error?.response?.status,
          data: error?.response.data,
        });
      }
    }
    setLoading(false);
  }
  const reset = () => {
    document.getElementById("reset-button-supplier").click();
    setDetails("");
    setAmount(0);
    setPayee("");
    setReference("");
    setValidationAttempted(false);
    getSupplierData(supplierRef);
    setmodalvalue();
    dispatch(clearFilesDispPayment());
  };

  const { uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      supplierRef: supplierRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };

  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const isModalMode = !!onClose;

  return (
    <div
      className={`d-flex ps-0 ms-0 g-0 flex-column h-100 ${
        isModalMode ? "" : "pb-3 h-100"
      }`}
    >
      <div
        className="d-flex flex-grow-1 pb-3"
        style={{ overflow: "hidden", minHeight: 0 }}
      >
        <div
          className="bgForm h-100 ms-2 pt-4 d-flex justify-content-center align-item-center"
          style={{
            minWidth: "350px",
            maxWidth: "350px",
            overflow: "auto",
          }}
        >
          <div className="w-100 px-4">
            <Form
              ignoreModified={true}
              onSubmit={Submithandler}
              initialValues={initialData}
              id="disbform"
              render={(formRenderProps) => {
                const supplierValue = formRenderProps.valueGetter("supplierRef");
                const officeBankValue = formRenderProps.valueGetter("officeBank");
                const feeEarnerValue = formRenderProps.valueGetter("feeEarner");
                
                return (
                  <FormElement name="disbform" id="disbform" noValidate>
                    <fieldset>
                      <div className="mb-3">
                        <SearchComboBox
                          name="supplierRef"
                          cbType={is_type ? CONSTANT.CR : CONSTANT.SR}
                          controlled={true}
                          onChangeFunction={onChangeSupplier}
                          width="auto"
                          boxShadow={true}
                          readOnly={isSupplierLocked}
                          error={validationAttempted && !supplierValue}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Date</Label>
                        <DatePicker
                          className={`${styles["showdow"]} px-1`}
                          value={dateselector}
                          onChange={onChangedateselect}
                          toggleButton={CalenderCustomToggleButton}
                        />
                      </div>
                      <div className="mb-3">
                        <SearchComboBox
                          name="officeBank"
                          cbType={CONSTANT.OB}
                          controlled={true}
                          width="auto"
                          boxShadow={true}
                          error={validationAttempted && !officeBankValue}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Reference</Label>
                        <Input
                          width={200}
                          value={reference}
                          onChange={(e) => {
                            setReference(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border: validationAttempted && !reference ? "1px solid red" : undefined,
                          }}
                        />
                      </div>
                      <div className="mb-3 right-align">
                        <Label className="label">Amount</Label>

                        <NumericTextBox
                          style={{
                            textAlign: "right",
                            boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 16px",
                          }}
                          value={amount}
                          onChange={(e) => {
                            setAmount(e.target.value);
                          }}
                          placeholder="0.00"
                          spinners={false}
                          format="n2"
                        />
                      </div>

                      <div className="mb-3">
                        <SearchComboBox
                          name="feeEarner"
                          cbType={CONSTANT.FE}
                          controlled={true}
                          width="auto"
                          boxShadow={true}
                          error={validationAttempted && !feeEarnerValue}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Payee</Label>
                        <Input
                          name="payee"
                          width={200}
                          value={payee}
                          onChange={(e) => {
                            setPayee(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border: validationAttempted && !payee ? "1px solid red" : undefined,
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Details</Label>

                        <TextArea
                          rows={4}
                          placeholder="Enter Details"
                          value={details}
                          onChange={(e) => {
                            setDetails(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border: validationAttempted && !details ? "1px solid red" : undefined,
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        <DocumentsUpload
                          progress={progress}
                          filesData={filesData}
                          onFileRemove={onFileRemove}
                          onUpload={handleUpload}
                          onError={() => {
                            const newFiles = filesData.splice(
                              filesData.length,
                              1
                            );
                            setFilesData([...newFiles]);
                          }}
                          type={"DUP"}
                        />
                      </div>
                      <button
                        id="reset-button-supplier"
                        type="reset"
                        style={{ visibility: "hidden" }}
                        onClick={() => formRenderProps.onFormReset()}
                      ></button>
                      <button
                        id="submit-button-supplier"
                        type="button"
                        style={{ visibility: "hidden" }}
                        onClick={() => {
                          setValidationAttempted(true);
                          formRenderProps.onSubmit();
                        }}
                      ></button>
                    </fieldset>
                  </FormElement>
                );
              }}
            />
          </div>
        </div>

        <div className="flex-grow-1 overflow-auto h-100 d-flex flex-column">
          <TransactionPeriod />

          <div
            className="mx-3 mt-3 h-100 d-flex flex-column"
            style={{ minHeight: "110px" }}
          >
            {!is_type && (
              <RadioGroup
                className="mb-3 me-3 ms-auto"
                layout="horizontal"
                data={typeData}
                value={type}
                onChange={(e) => setType(e.value)}
              />
            )}

            <PaySupplierGrid
              updateAllocations={handleUpdateAllocations}
              setAmount={handleSetAmount}
              type={type}
              data={data}
            />
            {!isModalMode && (
              <div className="buttonstyle justify-content-end">
                <Button
                  form="disbform"
                  className="common-btn"
                  onClick={() =>
                    document.getElementById("submit-button-supplier").click()
                  }
                  type="button"
                  disabled={loading}
                >
                  Post
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalMode && (
        <div className="dialog-footer d-flex justify-content-end gap-2 me-3">
          <Button
            className={`k-button common-btn bgBtnSecondary me-1`}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            form="disbform"
            className="common-btn"
            onClick={() =>
              document.getElementById("submit-button-supplier").click()
            }
            type="button"
            disabled={loading}
          >
            Post
          </Button>
        </div>
      )}

      <Modalposting
        data={modalvalue}
        closeModal={() => {
          setmodalvalue();
        }}
        reset={reset}
      ></Modalposting>
    </div>
  );
};
export default PaySupplier;
